/** @format */

export default function Block(_props) {
  return <></>;
}
